import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rneui/themed';

import Text from '../../themed/Text';

const useStyles = makeStyles((theme, props: InStoreCodeProps) => ({
  codeText: {
    // lineHeight: '125%',
    fontSize: 28,
  },
}));

type InStoreCodeProps = {
  color?: string;
  inStoreCode: string;
};

export default function InStoreCode({inStoreCode, color}: InStoreCodeProps) {
  const styles = useStyles();
  return (
    <View style={{marginTop: 20, alignSelf: 'stretch'}}>
      <Text color={color} variant="body2" style={{marginBottom: 8}}>
        Rewards in-store code
      </Text>
      {/* <Text style={[styles.codeText]}>{inStoreCode}</Text> */}
      <DisplayCode value={inStoreCode} />
    </View>
  );
}

/**
 * Show code as individual chars
 * @param param0
 * @returns
 */
function DisplayCode({value}: {value: string}) {
  return (
    <View style={{flexDirection: 'row', gap: 8}}>
      {value.split('').map((char, i) => {
        return (
          <View
            key={i}
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8,
              backgroundColor: '#EFEFEF',
              borderColor: '#D1D5DB',
              borderWidth: 1,
              flexGrow: 1,
              height: 44,
            }}>
            <Text
              style={{
                textSize: 22,
                marginTop: 3,
              }}>
              {char}
            </Text>
          </View>
        );
      })}
    </View>
  );
}
